import OrderStatusMap from '@/config/QuotationStatus.json';

const orderStatusMap:any = {};

export default ():{'20':string;  '25':string;  '30':string; '45':string; '55':string; '105':string;'35':string;'4':string;} => {
    OrderStatusMap.forEach((i:{value:number; text:string;}) => {
        orderStatusMap[i.value] = i.text;
    });
    return orderStatusMap;
}